import { Component, Injector, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { PonticSelectorService } from '@modules/tooth-editor/services/pontic-selector.service';
import { ControlValueAccessorDirective } from '@shared/base-classes/control-value-accessor.directive';
import { MapperPipe } from '@shared/pipes/mapper.pipe';
import { IdName } from '@shared/models/id-name';
import { TlkRadioButtonComponent } from '@itero/ui-toolkit-angular/radio-button';

@Component({
	selector: 'rx-pontic-selector',
	templateUrl: './pontic-selector.component.html',
	styleUrls: ['./pontic-selector.component.scss'],
	standalone: true,
	imports: [CommonModule, ReactiveFormsModule, MatTooltipModule, TranslateModule, MapperPipe, TlkRadioButtonComponent],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: PonticSelectorComponent,
			multi: true
		}
	]
})
export class PonticSelectorComponent extends ControlValueAccessorDirective<IdName> {
	@Input() isReadonly = false;
	@Input() name = '';
	@Input() showLabel = true;
	@Input() selectedValue: IdName | null = null;

	@Input()
	set options(value: IdName[]) {
		this.optionsWithDefault = [null, ...(value ?? [])];
	}
	optionsWithDefault: (IdName | null)[] = [null];

	constructor(
		private ponticSelectorService: PonticSelectorService,
		injector: Injector
	) {
		super(injector);
	}

	getSrcForPonticDesignImage(ponticDesign: IdName): string {
		return this.ponticSelectorService.getSrcForPonticDesignImage(ponticDesign);
	}

	isChecked(option: IdName | null): boolean {
		const value = this.selectedValue ?? this.control?.value;
		return option ? value?.Id === option.Id : !value;
	}

	onOptionSelect(option: IdName | null): void {
		this.control?.setValue(option as IdName);
	}
}
